import { useEffect, useMemo } from 'react';
import type { InfiniteData } from '@tanstack/react-query';

import {
	useSetIsVehicleCountLoading,
	useSetVehicleCount,
} from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import type { VehicleListItem } from 'Types/vehicle';

import type { VehicleListFetcher } from '../useFetchVehicleList/useFetchVehicleList.types';

import { getVehiclesCount } from './useVehicleListCount.helpers';

export interface UseVehicleListCountParams {
	isLoading?: boolean;
	selectedVehicle?: VehicleListItem;
	vehicles?: InfiniteData<VehicleListFetcher>;
}

const useVehicleListCount = ({ isLoading = false, selectedVehicle, vehicles }: UseVehicleListCountParams): number => {
	const setVehicleCount = useSetVehicleCount();
	const setIsVehicleCountLoading = useSetIsVehicleCountLoading();

	const vehicleCount = useMemo(() => getVehiclesCount({ selectedVehicle, vehicles }), [vehicles, selectedVehicle]);

	useEffect(() => {
		setVehicleCount(vehicleCount);
	}, [vehicleCount, setVehicleCount]);

	useEffect(() => {
		setIsVehicleCountLoading(isLoading);
	}, [isLoading, setIsVehicleCountLoading]);

	return vehicleCount;
};

export default useVehicleListCount;
